<template>
  <div
    v-if="itemCount"
    class="mb-5"
  >
    <div class="flex gap-3 p-3 rounded bg-editor-banner-bg-warning border border-editor-banner-border-warning">
      <FontAwesomeIcon
        :icon="faCircleExclamation"
        class="text-2xl text-warning"
      />

      <div>
        <p class="mb-2 font-bold leading-tight">
          This plan is incomplete
        </p>

        <p>
          {{ itemCount }} {{ itemCount === 1 ? 'item needs' : 'items need' }} attention. You can still submit, but we
          recommend resolving these first.
        </p>
      </div>
    </div>

    <div class="mt-4 border border-chrome-light rounded divide-y divide-chrome-light">
      <div
        v-for="group in groups"
        :key="group.title"
        class="p-3"
      >
        <div class="flex items-center justify-between mb-2">
          <p class="mb-0 font-bold leading-tight">
            {{ group.title }}
          </p>

          <span class="px-2 rounded-full bg-warning-subtle text-warning-dark text-xs font-semibold">
            {{ group.items.length }}
          </span>
        </div>

        <ul class="grid grid-cols-2 gap-x-8 gap-y-2">
          <li
            v-for="item in group.items"
            :key="item"
            class="flex gap-2"
          >
            <span class="w-2 h-2 mt-1.5 shrink-0 rounded-full border border-warning" />

            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';

import { PlanSectionName } from '@/const';

const props = defineProps({
  plan: {
    type: Object,
    required: true,
  },
});

const groups = computed(() => [
  {
    title: 'Required annexures not uploaded',
    items: props.plan.missingRequiredAnnexures ?? [],
  },
  {
    title: 'Sections with no content',
    items: (props.plan.blankSections ?? []).map((section) => PlanSectionName[section]),
  },
].filter((group) => group.items.length));

const itemCount = computed(() => groups.value.reduce((count, group) => count + group.items.length, 0));
</script>
